/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { Notary } from '../models/notary';

@Injectable({
  providedIn: 'root',
})
export class NotariesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getNotaries
   */
  static readonly GetNotariesPath = '/api/v1/Notaries';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getNotaries$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotaries$Plain$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<Notary>>> {

    const rb = new RequestBuilder(this.rootUrl, NotariesService.GetNotariesPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<Notary>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getNotaries$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotaries$Plain(params?: {
  },
  context?: HttpContext

): Observable<Array<Notary>> {

    return this.getNotaries$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<Notary>>) => r.body as Array<Notary>)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getNotaries()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotaries$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Array<Notary>>> {

    const rb = new RequestBuilder(this.rootUrl, NotariesService.GetNotariesPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<Notary>>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getNotaries$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotaries(params?: {
  },
  context?: HttpContext

): Observable<Array<Notary>> {

    return this.getNotaries$Response(params,context).pipe(
      map((r: StrictHttpResponse<Array<Notary>>) => r.body as Array<Notary>)
    );
  }

  /**
   * Path part for operation getNotaryById
   */
  static readonly GetNotaryByIdPath = '/api/v1/Notaries/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getNotaryById$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotaryById$Plain$Response(params: {
    id: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Notary>> {

    const rb = new RequestBuilder(this.rootUrl, NotariesService.GetNotaryByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Notary>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getNotaryById$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotaryById$Plain(params: {
    id: string;
  },
  context?: HttpContext

): Observable<Notary> {

    return this.getNotaryById$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<Notary>) => r.body as Notary)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getNotaryById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotaryById$Response(params: {
    id: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<Notary>> {

    const rb = new RequestBuilder(this.rootUrl, NotariesService.GetNotaryByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Notary>;
      })
    );
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getNotaryById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getNotaryById(params: {
    id: string;
  },
  context?: HttpContext

): Observable<Notary> {

    return this.getNotaryById$Response(params,context).pipe(
      map((r: StrictHttpResponse<Notary>) => r.body as Notary)
    );
  }

}
